import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { FadeUp, SectionTag } from "../components/motion";
import { INDUSTRIES } from "../data/content";
import useSEO from "../hooks/useSEO";

export default function Industries() {
  useSEO(
    "Industries Served — Government, Smart City, Banking, Healthcare, Education | SGSNet Patna",
    "SATI Global Systems (SGSNet) delivers CCTV surveillance, networking and IT projects for government & PSU, smart cities, corporate, banking, healthcare, education, industrial and airports & transportation sectors."
  );
  return (
    <main data-testid="industries-page" className="pt-16 sm:pt-24 pb-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <FadeUp><SectionTag>Industries</SectionTag></FadeUp>
        <FadeUp delay={0.1}>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.08] max-w-3xl">
            Where our systems <span className="text-blue-600">go to work.</span>
          </h1>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">
            From public-sector programs to private enterprise — technology delivered with the
            compliance, documentation and execution discipline each sector demands.
          </p>
        </FadeUp>

        <div className="mt-16 grid sm:grid-cols-2 gap-5">
          {INDUSTRIES.map((ind, i) => (
            <FadeUp key={ind.slug} delay={(i % 2) * 0.1}>
              <div className="group bg-panel border border-slate-200 rounded-2xl p-7 hover:border-blue-600/40 hover:bg-panelhover transition-colors duration-300 h-full"
                data-testid={`industry-card-${ind.slug}`}>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-lg bg-blue-600/10 border border-blue-600/30 flex items-center justify-center shrink-0">
                    <ind.icon size={22} className="text-blue-600" strokeWidth={1.6} />
                  </div>
                  <h2 className="font-heading text-xl font-semibold text-slate-900 group-hover:text-blue-700 transition-colors">{ind.name}</h2>
                </div>
                <p className="mt-4 text-sm text-slate-500 leading-relaxed">{ind.desc}</p>
                <ul className="mt-5 space-y-2">
                  {ind.points.map((p) => (
                    <li key={p} className="flex items-center gap-2.5 text-[13px] text-slate-600">
                      <CheckCircle2 size={14} className="text-blue-600/70 shrink-0" /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.15}>
          <div className="mt-16 rounded-2xl border border-slate-200 bg-gradient-to-br from-panel via-[#F8FAFC] to-obsidian p-8 sm:p-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div>
              <h2 className="font-heading text-2xl font-bold text-slate-900">Working on a sector-specific requirement?</h2>
              <p className="mt-2 text-sm text-slate-500">Our consultants map solutions to your industry's compliance and operational context.</p>
            </div>
            <Link to="/contact" data-testid="industries-cta"
              className="group inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-blue-600 text-[#FFFFFF] font-semibold text-sm hover:bg-blue-700 transition-colors shrink-0">
              Request a Consultation <ArrowUpRight size={15} />
            </Link>
          </div>
        </FadeUp>
      </div>
    </main>
  );
}
